import { forwardRef, useId } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'

type Size = 'sm' | 'md' | 'lg'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'onChange'> {
  checked?: boolean
  onChange?: (next: boolean) => void
  label?: ReactNode
  size?: Size
  loading?: boolean
  wrapperClassName?: string
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(function Checkbox(
  { checked, onChange, label, size = 'md', loading = false, disabled, className, wrapperClassName, id, ...rest },
  ref,
) {
  const autoId = useId()
  const inputId = id ?? autoId
  const classes = [
    'dsCb',
    size !== 'md' ? `dsCb--${size}` : '',
    disabled || loading ? 'is-disabled' : '',
    loading ? 'is-busy' : '',
    wrapperClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={classes} htmlFor={inputId}>
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className={`dsCb__input ${className ?? ''}`.trim()}
        checked={checked}
        onChange={(event) => onChange?.(event.target.checked)}
        disabled={disabled || loading}
        {...rest}
      />
      <span className="dsCb__box" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <polyline points="4,13 10,19 20,7" />
        </svg>
      </span>
      {label && <span className="dsCb__label">{label}</span>}
    </label>
  )
})
